import OutlinedButton from "@components/atoms/base-button/OutlinedButton";
import { translate } from "@locales";
import { useCheckoutActions } from "@models/interactions/use-checkout-actions/index";
import { useDrawer } from "@models/interactions/use-drawer/index";
import { Link } from "@shopify/hydrogen";

export function CheckoutActions() {
  const { models } = useCheckoutActions();
  const { operations: drawerOperations } = useDrawer();
  return (
    <>
      <div className="flex flex-col items-center mt-6 md:mt-8">
        <Link
          to={models.checkoutUrl}
          width="full"
          className="h-[50px] flex justify-center items-center rounded-sm font-medium text-center max-w-xl leading-none bg-black text-white w-full"
        >
          {translate("shop.cart.proceed-to-checkout")}
        </Link>
        <Link
          to="/cart"
          className="flex items-center justify-center rounded-sm mt-2 w-full h-[50px]"
        >
          <OutlinedButton
            className="w-full"
            onClick={() => drawerOperations.closeDrawer()}
          >
            {translate("shop.cart.view-cart")}
          </OutlinedButton>
        </Link>

        <div className="flex flex-col text-[12px] items-center mt-4">
          <p>
            * {translate("shop.cart.ship-and-returns.0")}{" "}
            <a
              href="/shipping-and-returns"
              className="underline text-blue-400"
            >
              {translate("shop.cart.ship-and-returns.1")}
            </a>
            {translate("shop.cart.ship-and-returns.2")}
            <br />
          </p>
          <span className="items-center">
            {translate("shop.cart.ship-and-returns.3")}
          </span>
        </div>
      </div>
    </>
  );
}
